// var customFirstLoad = true;
// let customSessionId = 0; // isolate from color filter session
// const customFilters = document.querySelectorAll(".js-custom-term");
// const customProductListWrapper = document.querySelector(".non-ajaxinate-container");
// const customProductList = customProductListWrapper.querySelector(".productgrid--items");

// function matchesFilterTerm(title, term) {
//   const parts = term.split(" ").map(t => t.trim().toLowerCase());
//   const lowerTitle = title.toLowerCase();
//   console.log(parts);
//   console.log(lowerTitle);
//   return parts.every(p => {
//     const regex = new RegExp(`\\b${p}\\b`, "i");
//     return regex.test(lowerTitle);
//   });
// }

// function normalizeFilterTerm(value) {
//   return value.toLowerCase().replace(/&/g, "_");
// }

// function getCustomBaseUrl() {
//   const url = new URL(window.location.href);
//   url.searchParams.delete("page");
//   return url.toString();
// }

// // Main filtering function
// async function applyCustomFilter(clicked) {
//     customSessionId++;
//     let selectedFilters = [];
//     document
//       .querySelectorAll(".js-custom-term.collection-filters__filter-list-item--active")
//       .forEach((el) => {
//         selectedFilters.push(normalizeFilterTerm(el.getAttribute("data-filter")));
//       });

//     document.querySelector(".products-loading").classList.add("hide");

//     if(clicked) {
//         document.querySelector(".productgrid--wrapper").scrollIntoView({ behavior: "smooth", block: "start" });
//     }

//     if (selectedFilters.length === 0) {
//       if (customFirstLoad) {
//         customFirstLoad = false;
//         return;
//       }
//       // No filter → show original infinite scroll
//       customProductList.innerHTML = "";
//       customProductListWrapper.classList.add('hide');
//       document.querySelector(".ajaxinate-container").classList.remove("hide");
//       document.querySelector('.product-count.bottom').classList.remove('hide');
//       return;
//     }

//     customProductList.innerHTML = "";
//     document.querySelector(".products-loading").classList.remove("hide");
//     customProductListWrapper.classList.remove('hide');
//     document.querySelector(".ajaxinate-container").classList.add("hide");
//     document.querySelector('.product-count.bottom').classList.add('hide');

//     await loadCustomProducts(getCustomBaseUrl(), selectedFilters, 1, customSessionId);
// }

// async function loadCustomProducts(baseUrl, filters, page, sessionId) {
//     if (sessionId !== customSessionId) return;

//     let nextLink = null;
//     if (page <= 10 || (page > 10 && customProductList.children.length > 0)) {
//       const urlObj = new URL(baseUrl, window.location.origin);
//       urlObj.searchParams.set("page", page);

//       const res = await fetch(urlObj.toString());
//       const text = await res.text();
//       const doc = new DOMParser().parseFromString(text, "text/html");

//       const products = [...doc.querySelectorAll(".productgrid--item")];
//       nextLink = doc.querySelector("a.paginate-next");

//       // Filter matches
//       let matches = [];
//       if (filters.length > 0) {
//         matches = products.filter((p) => {
//           const title = p.querySelector('.productitem--title').getAttribute("data-product-title") || "";
//           return filters.some((f) => matchesFilterTerm(title, f));
//         });
//       } else {
//         matches = products;
//       }

//       if (sessionId !== customSessionId) return;

//       if (matches.length > 0) {
//         document.querySelector(".products-loading").classList.add("hide");
//       }

//       matches.forEach((p) => {
//         customProductList.appendChild(p);
//       });
//     }

//     if (nextLink && sessionId === customSessionId) {
//       const nextPage = page + 1;
//       setTimeout(() => {
//         loadCustomProducts(baseUrl, filters, nextPage, sessionId);
//       }, 0);
//     } else {
//       if (!customProductList.children.length) {
//         document.querySelector(".products-loading").classList.add("hide");
//         customProductList.innerHTML = `<p>No products found for selected filter options.</p>`;
//       }
//     }
// }

// // Load selected filters from URL
// const customParams = new URLSearchParams(location.search);
// const customSelected = new Set(customParams.getAll("custom_filter").map(normalizeFilterTerm));
// customFilters.forEach((li) => {
//     const val = normalizeFilterTerm(li.getAttribute("data-filter"));
//     if (customSelected.has(val)) {
//         li.classList.add("collection-filters__filter-list-item--active");
//     }
// });

// // Click handler for custom filters
// document.querySelectorAll(".js-custom-term .collection-filters__filter-list-item-text").forEach((a) => {
//     a.addEventListener("click", function (e) {
//       e.preventDefault();
//       const parent = this.closest(".js-custom-term");
//       // toggle single active filter (like color behavior)
//     //   document.querySelectorAll(".js-custom-term.collection-filters__filter-list-item--active")
//     //     .forEach((el) => {
//     //       if (el !== parent) {
//     //         el.classList.remove("collection-filters__filter-list-item--active");
//     //       }
//     //     });

//       parent.classList.toggle("collection-filters__filter-list-item--active");
//       applyCustomFilter(true);
//     });
// });

// applyCustomFilter(false);


document.addEventListener("DOMContentLoaded", function () {
  let customFirstLoad = true;
  const customFilters = document.querySelectorAll(".js-custom-term");
  const customProductListWrapper = document.querySelector(".non-ajaxinate-container");

  // --- Extract filters from URL like the first script ---
  const pathParts = window.location.pathname.split("/").filter(Boolean);
  const selectedTagsFromUrl =
    pathParts.length > 2 ? pathParts[2].split("+") : [];

  const selectedNormalized = selectedTagsFromUrl.map((t) =>
    t.toLowerCase().replace(/\s+/g, "-")
  );

  // --- Highlight active terms (same as first script) ---
  customFilters.forEach((li) => {
    const val = li.getAttribute("data-filter")
      ?.toLowerCase()
      .replace(/\s+/g, "-");

    if (selectedNormalized.includes(val)) {
      li.classList.add("collection-filters__filter-list-item--active");
    }
  });

  // --- Tag click: Update URL ONLY (removes Ajax filtering) ---
  document
    .querySelectorAll(".js-custom-term .collection-filters__filter-list-item-text")
    .forEach((item) => {
      item.addEventListener("click", function (e) {
        e.preventDefault();

        const parent = this.closest(".js-custom-term");
        const filterValue = parent.getAttribute("data-filter") || "";

        // Handle complex terms like “Black & White”
        const tagParts = filterValue
          .split("&")
          .map((t) => t.trim().toLowerCase().replace(/\s+/g, "-"))
          .filter(Boolean);

        // Extract base collection
        const parts = window.location.pathname.split("/").filter(Boolean);
        const cIndex = parts.indexOf("collections");
        const collectionHandle = parts[cIndex + 1] || "";

        // Smooth scroll flag
        sessionStorage.setItem("scrollToProducts", "true");

        // Build Shopify tag URL
        const newUrl = `/collections/${collectionHandle}/${tagParts.join("+")}`;
        window.location.href = newUrl;
      });
    });

  // --- Smooth scroll after reload (same as first script) ---
  if (sessionStorage.getItem("scrollToProducts") === "true") {
    sessionStorage.removeItem("scrollToProducts");

    setTimeout(() => {
      customProductListWrapper?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 600);
  }
});